import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import Dashboard from './dashboard/Dashboard';
import CheckInWizard from './checkin/CheckInWizard';
import InsightsPanel from './insights/InsightsPanel';
import ExportPage from './export/ExportPage';
import ChatPage from './chat/ChatPage';
import RecoveryPage from './recovery/RecoveryPage';
import MealsPage from './meals/MealsPage';
import HistoryPage from './history/HistoryPage';
import SettingsPage from './settings/SettingsPage';
import NavBar from './components/NavBar';
import ProtectedRoute from './components/ProtectedRoute';

function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-app-gradient">
      <NavBar />
      <main className="max-w-4xl lg:max-w-6xl mx-auto px-4 lg:px-8 py-6">
        {children}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <AppLayout><Dashboard /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/checkin" element={
            <ProtectedRoute>
              <AppLayout><CheckInWizard key="new" /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/checkin/:id" element={
            <ProtectedRoute>
              <AppLayout><CheckInWizard key="edit" /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/meals" element={
            <ProtectedRoute>
              <AppLayout><MealsPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/history" element={
            <ProtectedRoute>
              <AppLayout><HistoryPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/insights" element={
            <ProtectedRoute>
              <AppLayout><InsightsPanel /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/export" element={
            <ProtectedRoute>
              <AppLayout><ExportPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/chat" element={
            <ProtectedRoute>
              <AppLayout><ChatPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/recovery" element={
            <ProtectedRoute>
              <AppLayout><RecoveryPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <AppLayout><SettingsPage /></AppLayout>
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
